var DevOps = "DevOps";
var Gaming = "遊戲";
var Migration = "遷移";
var Other = "其他";
var useCase = {
	"Use case": "應用案例",
	"AI & machine learning": "AI 與 Machine Learning",
	"Batch processing": "批次處理",
	"Big data, analytics, & business intelligence": "大數據、分析與商業智慧",
	"Business applications - Microsoft": "商業應用程式 - Microsoft",
	"Business applications - Oracle": "商業應用程式 - Oracle",
	"Business applications - Other": "商業應用程式 - 其他",
	"Business applications - SAP": "商業應用程式 - SAP",
	"Content delivery": "內容交付",
	DevOps: DevOps,
	Gaming: Gaming,
	"Internet of things": "物聯網",
	"Learning & certification": "學習與認證",
	"Media services": "媒體服務",
	Migration: Migration,
	"Mobile applications": "行動應用程式",
	Other: Other,
	"Storage & backup": "儲存與備份",
	"Websites & web apps": "網站與 Web 應用程式"
};

export { DevOps, Gaming, Migration, Other, useCase as default };
